export default __webpack_public_path__ + "static/media/Ribbon-Image.e13a7bdd.jpg";